import { combineReducers } from "redux";
import {
  checkLoginReducer,
  loginReducer,
  logoutReducer,
  registerReducer,
  resetPasswordMailSendReducer,
  resetPasswordReducer,
  verifyDomainReducer,
  googleAuthUserDetailsreducer,
} from "./authReducer";

// All combined reducers here.
export const reducers = combineReducers({
  register: registerReducer,
  login: loginReducer,
  resetPassword: resetPasswordReducer,
  logout: logoutReducer,
  checkLogin: checkLoginReducer,
  verifyDomain: verifyDomainReducer,
  resetPasswordMailSend: resetPasswordMailSendReducer,
  googleAuthUserDetails:googleAuthUserDetailsreducer,
});
